import { defineAsyncActionTypes } from 'store/common/action-helpers';

const prefix = 'graphql/UserClaimSurveyModal';
// FOR ONE GRAPHQL QUERY
export const USER_SEND_SURVEY = defineAsyncActionTypes(`${prefix}/USER_SEND_SURVEY`);



// WEBPACK FOOTER //
// ./src/store/graphql/UserClaimSurveyModal/action-types.js